import { Component, input } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { TypingTestIds } from './sb-typing.test-ids';

@Component({
  selector: 'app-sb-typing',
  imports: [MatCardContent, MatCard],
  templateUrl: './sb-typing.component.html',
  styleUrl: './sb-typing.component.scss'
})

/**
 * Komponente zur Anzeige einer Eingabeaktivität von Nutzern im Chat.
 * Zeigt an, wenn ein oder mehrere Nutzer gerade tippen.
 *
 * Es werden animierte Punkte als visuelle Darstellung der Eingabeaktivität verwendet.
 *
 * Keine AFOs erfüllt.
 */
export class SbTypingComponent {
  protected readonly testIds = TypingTestIds;
  typingUsers = input<string[]>([]);
  dots = [1, 2, 3];
}
